export default __webpack_public_path__ + "assets/images/gyra-white178a930a5e0ac1b87c1350f3bca20ca8.png";